import { useEffect, useCallback, useState, memo, useMemo } from "react";
import { Modal, ModalBody } from "reactstrap";
import { useAsync } from "../../../../../hooks";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Icon,
  LinearProgress,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./style.scss";
import { PhienLogsEndpoint } from "../../../../../service/Meet";
import { formatDatetime } from "../../../../../actions/util";
import DangKyPhatBieusEndpoint from "../../../../../service/Meet/DangKyPhatBieusEndpoint";
import { CHECK_WARNING } from "../../../../../components/alert/Alert";
import { StorageEndpoint } from "../../../../../service/GateWay";
import { toCanvas } from "html-to-image";
import jsPDF from "jspdf";

const Enum_Label_Log = {
  PHATBIEU: "phát biểu",
  BATDAU: "Bắt đầu phiên họp",
  VANDE: {
    Moi: "Thêm mới biểu quyết",
    HoanThanh: "Đã hoàn thành biểu quyết",
    HoatDong: "Bắt đầu biểu quyết",
  },
  KHUNGNOIDUNG: "hoàn thành",
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    magrin: "0px",
    flexBasis: "90%%",
    fontFamily:
      '"Mulish", system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji',
  },
}));

const DetailLog = memo(({ log }) => {
  const classes = useStyles();
  const json = JSON.parse(log.json);
  const [expanded, setExpanded] = useState(false);
  const [path, setPath] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (log && log.code === "PHATBIEU" && expanded) {
      DangKyPhatBieusEndpoint.getDataFullByID(log.key)
        .then((res) => {
          setPath(res.path);
        })
        .catch((err) => CHECK_WARNING(err));
    }
  }, [expanded, log]);

  const renderLabel = ({ code, status, json }) => {
    let label = "";
    switch (code) {
      case "PHATBIEU":
        label = (
          <p className="mb-1">
            {json?.TenChucDanh} - <b>{json?.Name}</b> {Enum_Label_Log[code]}{" "}
            {json?.NoiDung && <p>:"{json?.NoiDung}"</p>}
          </p>
        );
        break;
      case "BATDAU":
        label = (
          <p className="mb-1">
            {Enum_Label_Log[code]} <b>{json?.Name}</b>
          </p>
        );
        break;
      case "VANDE":
        label = (
          <p className="mb-1">
            {Enum_Label_Log[code][status]} <b>{json?.Name}</b>
          </p>
        );
        break;
      case "KHUNGNOIDUNG":
        label = (
          <p className="mb-1">
            Nội dung <b>{json?.Name}</b> {Enum_Label_Log[code]}{" "}
          </p>
        );
        break;
      default:
        break;
    }
    return label;
  };

  const renderExpandLog = useMemo(() => {
    return path ? (
      <audio
        className="w-100 audio"
        controls
        src={path && StorageEndpoint.getDocUrlByPath(path)}
      />
    ) : (
      <></>
    );
  }, [path]);

  return (
    <Accordion expanded={expanded} onChange={handleChange("panel")}>
      <AccordionSummary
        expandIcon={<Icon fontSize="small">arrow_upward</Icon>}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>
          <p className="mb-1">{formatDatetime(log.thoiGian)}</p>
          {renderLabel({ ...log, json })}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="d-block">
        <Typography>{renderExpandLog}</Typography>
      </AccordionDetails>
    </Accordion>
  );
});

function LogActivity({ close, isOpen }) {
  const [log, setLogs] = useState([]);

  const getDataTranfer = useCallback(async (phienHopId) => {
    try {
      const { value } = await PhienLogsEndpoint.getData(phienHopId);
      setLogs(value);
      return true;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleGetReport = useCallback(() => {
    // let div = document.getElementById('log-activity');
    // eslint-disable-next-line no-unused-vars
    // function resizeCanvas(canvas, newHeight, newWidth) {
    //     var context = canvas.getContext('2d');
    //     var imageData = context.getImageData(0, 0, canvas.width, canvas.width);
    //     canvas.putImageData(imageData, 0, 0, 0, 0, newWidth, newHeight);
    //     return canvas;
    // }
    // take image div
    // html2canvas(div, { scale: 2 }).then((canvas) => {
    //     var img_b64 = canvas.toDataURL('image/png');
    //     // var png = img_b64.split(',')[1];
    //     // var the_file = new Blob([Buffer.from(png, 'base64')], { type: 'image/png', encoding: 'utf-8' });
    //     // const objectURL = URL.createObjectURL(the_file);
    //     // const myImage = new Image();
    //     // myImage.src = objectURL;
    //     document.getElementById('myImg').setAttribute('src', img_b64)
    //     // console.log(the_file)
    // }).catch((err) => { })
  }, []);

  const handleExportImage = () => {
    const filter = (node) => {
      const exclusionClasses = ["material-icons", "audio"];
      return !exclusionClasses.some((classname) =>
        node.classList?.contains(classname)
      );
    };
    let node = document.getElementById("log-activity");
    // Lưu trữ kích thước ban đầu của thẻ
    // const originalHeight = node.scrollHeight;

    // Kéo dài kích thước của thẻ để bao gồm toàn bộ nội dung
    node.style.height = `${node.scrollHeight}px`;
    if (node) {
      toCanvas(node, { filter })
        .then((data) => {
          var dataUrl = data.toDataURL("image/png");
          // Tạo đối tượng jsPDF
          const pdf = new jsPDF("p", "px", "a4");

          // Lấy kích thước thực tế của hình ảnh (tính bằng pixel)
          const imgWidth = 300; // Kích thước A4
          const imgHeight = (node.scrollHeight / node.scrollWidth) * imgWidth;

          // Tính toán vị trí để đưa hình ảnh vào giữa tệp PDF
          const xOffset = (pdf.internal.pageSize.width - imgWidth) / 2;
          const yOffset = (pdf.internal.pageSize.height - imgHeight) / 4;

          // Thêm hình ảnh vào tệp PDF, điều chỉnh kích thước và vị trí
          pdf.addImage(dataUrl, "PNG", xOffset, yOffset, imgWidth, imgHeight);

          // Lưu hoặc hiển thị tệp PDF
          pdf.save("log_activity.pdf");
          node.style.height = `80vh`;

          // Xuất hình ảnh thành công, có thể sử dụng dataUrl
          // document.getElementById('myImg').setAttribute('src', img_b64)
        })
        .catch((error) => {
          node.style.height = `80vh`;
        });
    }
  };

  const { execute, status } = useAsync(getDataTranfer, false);

  useEffect(() => {
    isOpen && execute(isOpen);
  }, [execute, isOpen]);

  return (
    <Modal
      size="lg"
      isOpen={isOpen ? true : false}
      toggle={close}
      zIndex="1500"
    >
      <ModalBody>
        <div className="mb-1">
          <b>{isOpen?.phienHop?.name}</b>
        </div>
        <div id="log-activity" className="log-activity">
          {status === "pending" ? (
            <LinearProgress />
          ) : (
            <div className="container">
              <section>
                <h1>DIỄN BIẾN PHIÊN HỌP</h1>
              </section>
              <div style={{ color: "cadetblue" }} className="text-center">
                Bắt đầu
              </div>
              <div className="timeline">
                {log.map((cur, index) => {
                  return (
                    <article key={"logP" + index} className="row">
                      <div
                        className={`block slide-in-blurred-${
                          index % 2 === 0 ? "left" : "right"
                        }`}
                      >
                        <DetailLog {...{ log: cur }}></DetailLog>
                      </div>
                    </article>
                  );
                })}
              </div>
              <div style={{ color: "cadetblue" }} className="text-center">
                Kết thúc
              </div>
            </div>
          )}
        </div>
        <img id="myImg" alt=""></img>
        <div className="d-flex justify-content-end mt-2">
          <Button
            color="primary"
            size="small"
            startIcon={<Icon>assignment</Icon>}
            variant="contained"
            onClick={handleExportImage}
          >
            Xuất báo cáo
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default LogActivity;
